import { Theme } from '@mui/material';
import { css } from '@emotion/react';

export default (theme: Theme) => css`
	height: auto !important;
`;
